"use client";

import type { Dispatch, SetStateAction } from "react";
import { createContext } from "react";

import type { JWTPayload } from "../lib/types/schema/jwtSchema";
import type { OauthRefresh } from "../lib/types/schema/oauthRefreshSchema.schema";
import type { SessionStatus } from "./types/enums/sessionStatusEnum.enum";

export type SessionContext = {
  hasRefreshToken: boolean;
  jwtPayload: JWTPayload;
  login: ({ isNewUser, token }: { isNewUser: boolean; token: string }) => void;
  logout: ({ callback }: { callback?: () => any }) => void;
  refresh: ({
    callback,
  }?: {
    callback?: (data: OauthRefresh) => any;
  }) => Promise<OauthRefresh>;
  resetSessionURLSearchParameters: () => void;
  setSessionURLSearchParameters: ({
    isAuthenticated,
    isNewUser,
  }: {
    isAuthenticated: boolean;
    isNewUser: boolean;
  }) => void;
  setStatus: Dispatch<SetStateAction<SessionStatus>>;
  setToken: Dispatch<SetStateAction<null | string>>;
  status: SessionStatus;
  token: null | string;
};

export const sessionContext = createContext<SessionContext>({
  hasRefreshToken: false,
  jwtPayload: null,
  login: () => {},
  logout: () => {},
  refresh: () => Promise.resolve({} as OauthRefresh),
  resetSessionURLSearchParameters: () => {},
  setSessionURLSearchParameters: () => {},
  setStatus: () => {},
  setToken: () => {},
  status: "loading",
  token: null,
});
